import request from '@/utils/request';
const API_URL: string = '/Organization'

export function organization(uesMethod: string, params: ParamsInfo | null, data: number[] | DataInfo | null, funName: string = '') {
  return request({
    url: API_URL + funName,
    method: uesMethod,
    params,
    data
  });
}

export interface DataInfo {
  id?: number
  name: string
  departments?: any
  contactAddress?: string,
  contactPerson?: string,
  contactPhone?: string,
  contactEmail?: string,
  emergencyCall?: string,
  roles?: any[]
}

export interface ParamsInfo {
  id?: any
  organizationId?: any
  organizationName?: string
  pageNum?: number
  pageSize?: number
}

